import styled from 'styled-components';

export const TableStyles = styled.div`
  width: 100%;
  height: fit-content;
  border: 1px solid #eff2f7;
  border-radius: 0.5rem;
  overflow: hidden;

  table {
    margin: 0;

    .btn-clean-all {
      display: flex;
      height: 1.5rem;
      width: 100%;
      padding: 0.625rem 0.5rem;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      border: none;
      background-color: transparent;
      color: #2d3748 !important;
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 1rem;
    }
    .btn-clean-all:hover {
      background-color: #ffffff;
    }

    th {
      background-color: #f8f9fa;
      height: 2.5rem;
    }

    td {
      background-color: #ffffff;
      height: 2.5rem;
      overflow: visible;
    }
    tr:last-child {
      border-bottom: 1px solid transparent;
    }

    .btn-trash {
      display: flex;
      width: 2rem;
      height: 1.5rem;
      padding: 0.25rem;
      justify-content: center;
      align-items: center;
      border: none;
      background-color: transparent;
      font-size: 1rem;
      line-height: 1rem;
      font-weight: 600;
      color: #2d3748 !important;
    }
    .btn-trash:hover {
      background-color: #f8f9fa;
    }

    .text-no-keywords {
      color: #74788d;
      text-align: center;
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5rem;
    }
  }
`;
